import { UPDATE_UPCOMING_MATCHES } from '../actions/fantasy-cricket-action-types';

const initialState = {
  upcomingMatches: []
};

export default function screensData(state = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case UPDATE_UPCOMING_MATCHES:
      return {
        ...state,
        upcomingMatches: action.payload
      };
    default:
      return state;
  }
}
